import React from "react";
import Backgroundimage from "../../assets/images/background/banner-image-6.jpg";
import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore, { Navigation } from "swiper/core";
import quotesone from "../../assets/images/icons/quotes-1.png";

SwiperCore.use([Navigation]);

function Testimonialsabout() {
    const show = {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            },
        },
    };

    return (
        <section className="testimonials-two">
            <div
                className="image-layer"
                style={{ backgroundImage: `url(${Backgroundimage})` }}
            ></div>
            <div className="auto-container">
                <div className="title-box centered">
                    <div className="subtitle">
                        <span>testimonials</span>
                    </div>
                    <div className="pattern-image">
                        <img
                            src={
                                require("../../assets/images/icons/separator.svg")
                                    .default
                            }
                            alt="mySvgImage"
                        />
                    </div>
                    <h2>What People Are Saying</h2>
                </div>

                <div className="carousel-box">
                    <Swiper className="testimonial-slider" {...show}>
                        <SwiperSlide className="testi-block item">
                            <div className="inner-box">
                                <div className="quote-icon">
                                    <img src={quotesone} alt="" title="" />
                                </div>
                                <div className="rating">
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                </div>
                                <div className="text">
                                    I can only speak to breakfast which is a
                                    regular stop for us. What can you say about
                                    a place that cooks their eggs in butter. The
                                    eggs Benedict are first rate especially with
                                    smoked salmon. There is a large breakfast
                                    menu for all tastes and appetites. Service
                                    is consistently excellent .
                                </div>
                                <div className="auth-info">
                                    <div className="image">
                                        <img src={"https://dynamic-media-cdn.tripadvisor.com/media/photo-o/06/08/93/9d/612brian612.jpg?w=200&h=-1&s=1"} alt="" />
                                    </div>
                                    <div className="auth-title">
                                        612Brian612
                                    </div>
                                    <div className="location">Edmonton, Canada</div>
                                    <div className="location">November 23, 2025</div>
                                </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide className="testi-block item">
                            <div className="inner-box">
                                <div className="quote-icon">
                                    <img src={quotesone} alt="" title="" />
                                </div>
                                <div className="rating">
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                </div>
                                <div className="text">
                                    Excellent breakfast! 
                                    Eggs Benedict was very good. 
                                    Not sure how they cook the breakfast potatoes, 
                                    but they were excellent!
                                </div>
                                <div className="auth-info">
                                    <div className="image">
                                        <img src={"https://dynamic-media-cdn.tripadvisor.com/media/photo-o/10/e5/73/a9/sstallygal.jpg?w=200&h=-1&s=1"} alt="" />
                                    </div>
                                    <div className="auth-title">
                                        Theresa Tin
                                    </div>
                                    <div className="location">Florida</div>
                                    <div className="location">September 13, 2025</div>
                                </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide className="testi-block item">
                            <div className="inner-box">
                                <div className="quote-icon">
                                    <img src={quotesone} alt="" title="" />
                                </div>
                                <div className="rating">
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                </div>
                                <div className="text">
                                    We've been here before. As usual a GREAT meal! Eggs Benedict delicious and the thin fried potato chips excellent. Our server Chet was great - food arrived quickly. We'll be back!
                                </div>
                                <div className="auth-info">
                                    <div className="image">
                                        <img src={"https://dynamic-media-cdn.tripadvisor.com/media/photo-o/1a/f6/e4/2d/default-avatar-2020-48.jpg?w=200&h=-1&s=1"} alt="" />
                                    </div>
                                    <div className="auth-title">
                                        colin b
                                    </div>
                                    <div className="location">April 24, 2025</div>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                    <div className="swiper-button-prev">
                        <span className="fal fa-angle-left"></span>
                    </div>
                    <div className="swiper-button-next">
                        <span className="fal fa-angle-right"></span>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonialsabout;
